<template>
  <v-breadcrumbs v-if="stack.length > 0" :items="breadcrumbItems" class="pa-0 mb-3">
    <template #item="{ item }">
      <v-breadcrumbs-item
        :disabled="item.disabled"
        @click="$emit('navigate', item.index)"
      >
        {{ item.text }}
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>

<script>
export default {
  props: {
    stack: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    breadcrumbItems() {
      const items = [{ text: 'Root', index: -1, disabled: false }]
      for (let i = 0; i < this.stack.length; i++) {
        items.push({
          text: this.stack[i].label || this.stack[i].key,
          index: i,
          disabled: i === this.stack.length - 1,
        })
      }
      return items
    },
  },
}
</script>
